module.exports = __webpack_public_path__ + "media/images/front/icon_spmenu_star-d8fb9520cc12a0f6a3706cc7679cdf0c.png";